import React from 'react';
import SelectGroup from './SelectGroup';
import './ScoreSettings.scss';
import reducerStore from '../../reducers/reducerStore';

class ScoreSettings extends React.Component {

    renderSelectedType(criteria, props) {
        let selectedType = criteria.type;
        switch (selectedType) {
            case 'Activity': {
                return (<div><span className="text">{`${selectedType} Types`}</span>
                    <div>
                        <SelectGroup
                            title='Aktivitetstyper'
                            label='name'
                            endpoint='activityTypes/activity'
                            group='category.name'
                            criteria={criteria}
                            field='selectedTypes'
                            index={props.index}
                            setWidgetFieldValue={(field, value) => { reducerStore.dispatch({ type: 'UPDATE_COMPETITION_CRITERIA', property: field, value: value, index: props.index, slideId: props.slideId, isNew: props.isNew }); }}
                            widget={props.widget}
                            placeholder="Samtliga"
                        />
                    </div></div>);
            }

            case 'Appointment': {
                return (<div><span className="text">{`${selectedType} Types`}</span>
                    <div>
                        <SelectGroup
                            title='Aktivitetstyper'
                            label='name'
                            endpoint='activityTypes/appointment'
                            group='category.name'
                            criteria={criteria}
                            field='selectedTypes'
                            index={props.index}
                            setWidgetFieldValue={(field, value) => { reducerStore.dispatch({ type: 'UPDATE_COMPETITION_CRITERIA', property: field, value: value, index: props.index, slideId: props.slideId, isNew: props.isNew }); }}
                            widget={props.widget}
                            placeholder='Samtliga'
                        />
                    </div></div>);
            }

            case 'Sales': {
                return (<div><span className="text">{`Order Stages`}</span>
                    <div>
                        <SelectGroup
                            title='Faser'
                            label='name'
                            endpoint='orderstage?type=order'
                            group=''
                            criteria={criteria}
                            field='selectedTypes'
                            index={props.index}
                            setWidgetFieldValue={(field, value) => { reducerStore.dispatch({ type: 'UPDATE_COMPETITION_CRITERIA', property: field, value: value, index: props.index, slideId: props.slideId, isNew: props.isNew }); }}
                            widget={props.widget}
                            placeholder="Samtliga"
                        />
                    </div></div>);
            }

            case 'Opportunity': {
                return (<div><span className="text">{`${selectedType} Stages`}</span>
                    <div>
                        <SelectGroup
                            title='Faser'
                            label='name'
                            endpoint='orderstage?type=opportunity'
                            group=''
                            criteria={criteria}
                            field='selectedTypes'
                            index={props.index}
                            placeholder='Samtliga'
                            setWidgetFieldValue={(field, value) => { reducerStore.dispatch({ type: 'UPDATE_COMPETITION_CRITERIA', property: field, value: value, index: props.index, slideId: props.slideId, isNew: props.isNew }); }}
                            widget={props.widget}
                        />
                    </div></div>);
            }
        }
    }

    render() {
        const { widget, criteria, setValue, slideId } = this.props;

        if (!widget) {
            return (<div className="competition-container" />);
        }

        const options = [
            {
                title: 'Activity',
                value: 'Activity',
            },
            {
                title: 'Appointment',
                value: 'Appointment',
            },
            {
                title: 'Opportunity',
                value: 'Opportunity',
            },
            {
                title: 'Sales',
                value: 'Sales',
            },
        ];

        let type = 'Activity'; //default type

        let statusButtons = [];

        if (criteria.type === 'Activity') {
            statusButtons.push('All', 'Created', 'Closed');
        } else if (criteria.type === 'Appointment') {
            statusButtons.push('All', 'Booked', 'Completed');
        }

        let statusButtonList;
        statusButtonList = statusButtons.map((buttonText, i) => {
            const internalClassName = ['status-btn'];

            if (criteria.status === buttonText) {
                internalClassName.push('status-btn-active');
            }

            return <button
                key={i}
                value={buttonText}
                className={internalClassName.join(' ')}
                onClick={(event) => this.buttonClicked(event, this)}
            >{buttonText}</button>
        });

        return (
            <div className="score-settings">
                <div className="left-pane">
                    <div className="row1">
                        <span className="text">Type</span>
                        <div>
                            <select value={criteria.type} onChange={event => { setValue(event.target.value, this.props.index); this.type = event.target.value; }}>
                                {options.map((o, i) => <option key={i} value={o.value}>{o.title}</option>)}
                            </select>
                        </div>
                    </div>

                    <div className="row2">
                        {this.renderSelectedType(criteria || 'Activity', this.props)}
                    </div>
                </div>

                <div className="right-pane">
                    {/*render status buttons for Activity and Appointment*/}
                    {statusButtonList.length > 0 && <div className="row1">
                        <span className="text">Status</span>
                        <div className="buttons">
                            {statusButtonList}
                            <button className='trash-btn' onClick={() => { this.removeCriteria(criteria, slideId) }}>
                                <i className='fa fa-trash' />
                            </button>
                        </div>
                    </div>}

                    {/*do not render status buttons for sales and opportunity*/}
                    {statusButtonList.length == 0 && <div className="row1">
                        <div className="buttons" style={{ paddingLeft: "282px", paddingBottom: "8px" }}>
                            <button className='trash-btn'
                                onClick={() => { this.removeCriteria(criteria, slideId) }}>
                                <i className='fa fa-trash' />
                            </button>
                        </div>
                    </div>}

                    <div className="row2">
                        <span className="text">Points per event</span>
                        <div className="points-input">
                            <input type="number" className="input" value={criteria.points} onChange={event => { reducerStore.dispatch({ type: 'UPDATE_COMPETITION_CRITERIA', property: 'points', value: event.target.value, index: this.props.index, slideId: slideId, isNew: this.props.isNew }); }} />
                        </div>
                    </div>
                </div>

            </div>);
    }

    removeCriteria(criteria, slideId) {
        let currentState = reducerStore.getState();
        let storedCriterias;

        currentState.slides.some(slide => {
            if (slide.type === 'competition' && slide.id === slideId && !this.props.isNew) {
                storedCriterias = slide.competitionSettings.criterias;
                return true;
            } else if (slide.type === 'competition' && !slide.id && this.props.isNew) {
                storedCriterias = slide.competitionSettings.criterias;
                return true;
            }
        });

        let updatedCriterias = storedCriterias.filter(item => item.id !== criteria.id);

        //adjust the indices and ids
        updatedCriterias.forEach((item, index) => {
            if (item.id != index) {
                item.id = item.id - 1;
            }
        });

        reducerStore.dispatch({ type: 'DELETE_COMPETITION_CRITERIA', value: updatedCriterias, slideId: slideId, isNew: this.props.isNew });
    }

    buttonClicked(e, context) {
        //update redux store
        reducerStore.dispatch({ type: 'UPDATE_COMPETITION_CRITERIA', property: 'status', value: e.target.value, index: context.props.index, slideId: context.props.slideId, isNew: context.props.isNew });
    }
}

ScoreSettings.propTypes = {
    widget: React.PropTypes.object,
    criteria: React.PropTypes.object,
    setValue: React.PropTypes.func,
    setWidgetFieldValue: React.PropTypes.func,
    index: React.PropTypes.number
};
export default ScoreSettings;



/** WEBPACK FOOTER **
 ** ./client/components/SettingsModal/ScoreSettings.jsx
 **/